module.exports = __webpack_public_path__ + "static/img/honor-2.1e4e0c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-2.png
// module id = 4uys
// module chunks = 0